import { Form_ProjectUserGroupFieldArray } from './Form_ProjectUserGroupFieldArray';
import { Form_SystemUserGroupFieldArray } from './Form_SystemUserGroupFieldArray';
import { Form_UserFieldArray } from './Form_UserFieldArray';

export const ArrayInputs = {
    User_Array: Form_UserFieldArray,
    SystemUserGroup_Array: Form_SystemUserGroupFieldArray,
    ProjectUserGroup_Array: Form_ProjectUserGroupFieldArray,
};
